import { render, staticRenderFns } from "./ListaCompras.vue?vue&type=template&id=0aacfcb6&scoped=true&"
import script from "./ListaCompras.vue?vue&type=script&lang=js&"
export * from "./ListaCompras.vue?vue&type=script&lang=js&"
import style0 from "./ListaCompras.vue?vue&type=style&index=0&id=0aacfcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aacfcb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
